import { useEffect } from 'react'

import { useHeaderStore } from '@/stores/useHeaderStore'
import { useStreamEventStore } from '@/stores/useStreamEventStore/useStreamEventStore'
import { StreamEvent } from '@/types/streams/event'

const EventStore = ({ event: initialFetchedEvent }: { event: StreamEvent }) => {
  const { setTitle } = useHeaderStore()
  const { streamEvent, setStreamEvent } = useStreamEventStore()
  if (!streamEvent) {
    setStreamEvent(initialFetchedEvent)
  }

  const event = streamEvent || initialFetchedEvent

  useEffect(() => {
    setTitle(event?.streamingConfig?.isLive ? `${event.title} - LIVE` : event.title)
  }, [event?.streamingConfig?.isLive, event.title, setTitle])

  return null
}

export default EventStore
